import { Component, OnInit, Self } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { EntityModalComponent } from "../../../util/components/modal/entity-modal.component";
import { EnumService } from "../../../util/service/enum.service";
import { OfficeFormGroupService } from "../office-form-group.service";
import { CaslAction } from "../../../server/enums/casl-action.enum";
import { EntityTyp } from "../../../util/enums/entity-typ.enum";
import { OfficeDto } from "app/api/models";
import { OfficeType } from "../../../server/enums/office-type.enum";

@Component({
    selector: "app-office-modal",
    templateUrl: "./office-modal.component.html",
    styleUrls: ["./office-modal.component.scss"],
    providers: [OfficeFormGroupService],
    standalone: false
})
export class OfficeModalComponent extends EntityModalComponent<OfficeDto> implements OnInit {
  officeTypes!: Array<{ value: string }>;
  protected readonly CaslAction = CaslAction;
  protected readonly EntityTyp = EntityTyp;

  constructor(
    @Self() public formGroupService: OfficeFormGroupService,
    public modal: NgbActiveModal,
    private enumService: EnumService
  ) {
    super();
  }

  override ngOnInit(): void {
    this.officeTypes = this.enumService.officeTypeDropdownOptions;
    super.ngOnInit();
  }

  protected readonly OfficeType = OfficeType;
}
